import script from "./PrivateLabelFileUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivateLabelFileUpload.vue?vue&type=script&setup=true&lang=ts"

import "./PrivateLabelFileUpload.vue?vue&type=style&index=0&id=1d5503d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d5503d6"]])

export default __exports__